<div class="modal" [id]="id" tabindex="-1" role="dialog">
  <div [ngClass]="(ultralarge) ? 'modal-dialog modal-ultralg' : (!large) ? 'modal-dialog' : 'modal-dialog modal-lg'" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info">
        <h5 class="modal-title text-white w-100"><ng-content select="[modal-title]"></ng-content></h5>
        <button *ngIf="canIclose" type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-content select="[modal-body]"></ng-content>
      </div>
    </div>
  </div>
</div>
